import styled from 'styled-components'

import { _L_Medium, _M_Medium, _M_Normal, mainColors, semanticColors } from '../../../styles'
import { AIBannerTheme } from '../AIElements.types'

const BUTTON_WIDTH = 115

export const ButtonWrapper = styled.div`
  button {
    width: ${BUTTON_WIDTH}px;
    max-width: ${BUTTON_WIDTH}px;
    border-color: ${semanticColors.aiDark} !important;
    background-color: ${mainColors.white} !important;
    color: ${semanticColors.aiDark} !important;

    &:hover {
      background-color: ${semanticColors.aiDark} !important;
      border-color: ${semanticColors.aiDark} !important;
      color: ${semanticColors.aiExtraLight} !important;
    }

    &:active {
      background-color: ${semanticColors.aiDark} !important;
      border-color: ${semanticColors.aiDark} !important;
      color: ${semanticColors.aiExtraLight} !important;
    }
  }
`

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;

  svg {
    max-height: 16px;
    max-width: 16px;
  }
`

export const Title = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${_M_Medium};
  white-space: nowrap;
  align-items: center;
  color: ${semanticColors.aiDark};
  gap: 16px;
  justify-content: space-between;
`

export const Description = styled.div<{ $isPlainText?: boolean }>`
  ${_M_Normal};
  color: ${mainColors.neutralExtremelyDark};
  line-height: 1.4;

  ${({ $isPlainText }) => $isPlainText && `white-space: pre-wrap;`}

  p:not(:last-of-type) {
    margin-bottom: 12px;
  }
`

export const Root = styled.div<{ theme: AIBannerTheme }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid;
  padding: 16px;

  ${({ theme }) =>
    theme === AIBannerTheme.light &&
    `
      background: linear-gradient(91deg, ${mainColors.white} 39%, ${semanticColors.aiExtraLight} 100%);
      border-color: ${semanticColors.aiLight};
  `}

  ${({ theme }) =>
    theme === AIBannerTheme.lightDashed &&
    `
      background: linear-gradient(91deg, ${mainColors.white} 39%, ${semanticColors.aiExtraLight} 100%);
      border-color: ${semanticColors.aiLight};
      border-style: dashed;
  `}
`

// Collapsible Card
export const CardBorder = styled.div`
  background: linear-gradient(90deg, ${semanticColors.aiExtremelyLight}, ${semanticColors.aiDark});
  padding: 1px;
  border-radius: 8px;
`

export const Card = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  background: ${mainColors.white};
  border-radius: 7px;
  gap: 12px;
`

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  ${_L_Medium};
  color: ${mainColors.black};
  cursor: pointer;
`

export const ContentWrapper = styled.div`
  width: 100%;
  ${_M_Normal};
  color: ${mainColors.neutralExtremelyDark};
  line-height: 1.5;
  overflow-wrap: break-word;

  p:not(:last-of-type) {
    margin-bottom: 12px;
  }

  ul {
    padding-left: 13px;
  }

  h3 {
    ${_M_Medium};
    padding-top: 8px;
  }
`

export const CardIcon = styled.div`
  display: flex;
  border-radius: 8px;
  background: ${semanticColors.aiExtremelyLight};
  align-items: center;
  padding: 2px;
  color: ${semanticColors.aiDark};
`

export const IconCollapsible = styled.div<{ scale: number }>`
  display: flex;
  align-items: center;
  width: 36px;
  height: 36px;

  svg {
    width: 20px;
    height: 20px;
    color: ${mainColors.accentMedium};
    scale: ${({ scale }) => scale};
  }

  &:hover {
    cursor: pointer;

    svg {
      color: ${mainColors.accentDark};
    }
  }
`

// Rate Response

export const RateResponseWrapper = styled.div<{ scale?: number }>`
  display: flex;
  cursor: pointer;

  svg {
    color: ${semanticColors.aiDark};
    scale: ${({ scale }) => scale};
  }
`
